//export const URLAPI = "https://pruebas.back.ingreso.orocash.ec";
export const URLAPI = "https://back-ingreso.orocash.ec";

//export const WEBSOCKET = "wss://pruebas.back.ingreso.orocash.ec";
export const WEBSOCKET = "wss://back-ingreso.orocash.ec";

export const LOGIN_PATH = "/token/";
export const TASK_PATH = "/employee/task/";

export const GET_SETTINGS_ALL_PATH = "/settings/";

export const COMPANY_PATH = "/company/list/";
export const COMPANY_UPDATE_PATH = "/company/update/";
export const COMPANY_CREATE_PATH = "/company/create/";

export const ESTABLISHMENT_PATH = "/establishment/list/";
export const ESTABLISHMENT_UPDATE_PATH = "/establishment/update/";
export const ESTABLISHMENT_CREATE_PATH = "/establishment/create/";
export const ZONE_PATH = "/zone/list/";
export const ZONE_UPDATE_PATH = "/zone/update/";
export const ZONE_CREATE_PATH = "/zone/create/";
export const EMPLOYEE_PATH = "/employee/list/";
export const EMPLOYEE_VEHICLE_PATH = "/employee/vehicle/list/";
export const EMPLOYEE_DETAIL_PATH = "/employee/detail/";
export const EMPLOYEE_UPDATE_PATH = "/employee/update/";
export const EMPLOYEE_CREATE_PATH = "/employee/create/";
export const EMPLOYEE_CREATE_LINK_PATH = "/employee/photo-upload-link/create/";
export const EMPLOYEE_UPDATEPHOTO_PATH = "/employee/updatephoto/";
export const EMPLOYEE_IMPORT_PATH = "/employee/import/";
export const EMPLOYEE_REPORT_PATH = "/employee/report/";
export const BONUS_REPORT_PATH = "/employee/report-bonus/";
export const FORM_EMPLOYEE_REPORT_PATH = "/employee/form-report/";
export const EMPLOYEE_REPORT_CHECK_PATH = "/employee/report/check/";
export const EMPLOYEE_VALIDATE_LINK_PATH = "/employee/validate-link-photo/";
export const SEND_EMAIL_SETTING_PATH = "/employee/send-email-setting/";

export const CERTIFCATE_DOWNLOAD_PDF_PATH = "/employee/certificate/download/pdf/";
export const FORMULARIO_PDF_PATH = "/employee/section/formulario/download/pdf/";

export const LOGS_EMPLOYEE_PATH = "/employee/logs/";
export const REPORT_LOGS_EMPLOYEES_PATH = "/employee/report-logs/";
export const LOGS_AFFILIATIONS_EMPLOYEE_PATH = "/employee/logs/affiliations/";
export const REPORT_LOGS_AFFILIATIONS_EMPLOYEES_PATH = "/employee/report-logs-affiliations/";
export const LOGS_ABSENCE_EMPLOYEE_PATH = "/employee/logs/absence/";
export const LOG_ABSENCE_EMPLOYEE_CREATE_PATH = "/employee/logs/absence/create/";
export const REPORT_LOGS_ABSENCE_EMPLOYEES_PATH = "/employee/report-logs-absence/";

export const EMAIL_SETTING_PATH = "/employee/email-setting/list/";
export const EMAIL_SETTING_UPDATE_PATH = "/employee/email-setting/update/";
export const EMAIL_SETTING_CREATE_PATH = "/employee/email-setting/create/";
export const EMAIL_SETTING_DELETE_PATH = "/employee/email-setting/delete/";

export const REASON_DISMISSAL_PATH = "/employee/reason-dismissal/list/";
export const REASON_DISMISSAL_UPDATE_PATH = "/employee/reason-dismissal/update/";
export const REASON_DISMISSAL_CREATE_PATH = "/employee/reason-dismissal/create/";

export const REASON_MOVEMENT_PATH = "/employee/reason-movement/list/";
export const REASON_MOVEMENT_UPDATE_PATH = "/employee/reason-movement/update/";
export const REASON_MOVEMENT_CREATE_PATH = "/employee/reason-movement/create/";

export const JOBS_PATH = "/job/list/";
export const JOBS_UPDATE_PATH = "/job/update/";
export const JOBS_CREATE_PATH = "/job/create/";

export const SUPPLIER_PATH = "/supplier/list/";
export const SUPPLIER_UPDATE_PATH = "/supplier/update/";
export const SUPPLIER_DELETE_PATH = "/supplier/delete/";
export const SUPPLIER_CREATE_PATH = "/supplier/create/";

export const USERS_PATH = "/user/list/";
export const USERS_UPDATE_PATH = "/user/update/";
export const USERS_CREATE_PATH = "/user/create/";
export const USER_GROUPS_PATH = "/user/group-list/";
export const USER_GET_PATH = "/user/get/";
export const USER_GET_ALL_PERMISSIONS_PATH = "/user/permission-list/";
export const USER_CREATE_GROUP_PATH = "/user/group-create/";
export const USER_UPDATE_GROUP_PATH = "/user/group-update/";
export const USER_ACTIVATE_PATH = "/user/activate/";
export const USER_LOGOUT_PATH = "/user/logout/";
export const USER_PASSWORD_RESET_PATH = "/user/password/reset/";
export const USER_PASSWORD_RESET_CONFIRM_PATH = "/user/password/reset/confirm/";
export const USERS_UPDATE_PASSWORD_PATH = "/user/update-password/";

export const VISITANT_PATH = "/visitant/list/";
export const VISITANT_UPDATE_PATH = "/visitant/update/";
export const VISITANT_DELETE_PATH = "/visitant/delete/";
export const VISITANT_CREATE_PATH = "/visitant/create/";

export const VISITS_PATH = "/visit/list/";
export const VISIT_ITEM_PATH = "/visit/item/";
export const VISITS_UPDATE_PATH = "/visit/update/";
export const SEARCH_VISITANT_PATH = "/employee/employees-supplier-visitant-list/";
export const GET_EMPLOYEE_ZONE_PATH = "/visit/get-employee-zone/";
export const VISITS_CREATE_PATH = "/visit/create/";
export const VISITS_REPORT_PATH = "/visit/report/";
export const VISITS_REPORT_CHECK_PATH = "/visit/report/check/";
export const VISIT_MONITORING_REPORT_PATH = "/visit/monitoring/report/";
export const VISIT_MONITORING_REPORT_CHECK_PATH = "/visit/monitoring/report/check/";
export const VISITS_DETAILS_PATH = "/visit/detail/";
export const VISITS_REQUIRED_EXIT_PATH = "/visit/required-exit/";
export const VISITS_RESPONSE_EXIT_PATH = "/visit/response-exit/";


export const TYPE_DAY_PATH = "/employee/type-day/list/";

export const DEPARTURES_PATH = "/departure/employee/list/";
export const DEPARTURES_PERSONAL_PATH = "/departure/employee/personal/list/";
export const DEPARTURE_DETAILS_PATH = "/departure/employee/detail/";
export const DEPARTURES_EMERGENCY_CREATE_PATH =
  "/departure/employee/emergency/create/";
export const DEPARTURES_SCHEDULED_CREATE_PATH =
  "/departure/employee/scheduled/create/";
  export const DEPARTURES_RECURRENT_CREATE_PATH =
  "/departure/recurring/create/";
export const DEPARTURES_APPROVED_DENIED_PATH = "/departure/employee/approved-denied/";
export const DEPARTURES_ACCEPT_DECLINE_PATH = "/departure/employee/approval/";
export const DEPARTURES_UPDATE_PATH = "/departure/employee/required/";
export const ABSENCE_DAYS_PATH = "/departure/employee/absence-days/update/"
export const DEPARTURES_REPORT_PATH = "/departure/employee/report/";
export const DEPARTURES_STATISTICS_PATH = "/departure/employee/statistics/";
export const DEPARTURES_STATISTICS_YEAR_PATH = "/departure/employee/statistics/year/";
export const DEPARTURES_REPORT_CHECK_PATH = "/departure/employee/report/check/";

export const VISITS_DEPARTURES_MONITORING_PATH = "/visit/list-monitoring/"

export const DEPARTURES_REASONS_TYPES_PATH = "/departure/list/";
export const DEPARTURES_REASONS_PATH = "/departure/reasons/list/";
export const DEPARTURES_REASONS_UPDATE_PATH = "/departure/reason/update/";
export const DEPARTURES_REASONS_CREATE_PATH = "/departure/reason/create/";

export const REASON_DECLINE_PATH = "/departure/reason-decline/list/";
export const REASON_DECLINE_UPDATE_PATH = "/departure/reason-decline/update/";
export const REASON_DECLINE_CREATE_PATH = "/departure/reason-decline/create/";

export const INCOME_PATH = "/income/list/";
export const REQUEST_OPENING_PATH = "/income/request-opening/";
export const REQUEST_APPROVAL_PATH = "/income/request-opening-approval/";
export const INCOME_UPDATE_PATH = "/income/update/";
export const INCOME_CREATE_PATH = "/income/create/";
export const INCOME_DETAILS_PATH = "/income/detail/";
export const INCOME_REPORT_PATH = "/income/report/";
export const INCOME_REPORT_CHECK_PATH = "/income/report/check/";

export const EMAIL_CREATE_PATH = "/zone/email/create/";
export const EMAIL_UPDATE_PATH = "/zone/email/update/";
export const EMAIL_DELETE_PATH = "/zone/email/delete/";

export const BANK_PATH = "/bank/list/";
export const BANK_CREATE_PATH = "/bank/create/";
export const BANK_UPDATE_PATH = "/bank/update/";

export const EMPLOYEE_FORM_PATH = "/employee/form/list/";
export const ITEM_EMPLOYEE_FORM_PATH = "/employee/form/item/";
export const FORM_UPDATE_PATH = "/employee/form/update/";
export const SEND_FORM_EMPLOYEE_PATH = "/employee/form/send/";
export const FORM_FIELD_UPDATE_PATH = "/employee/form/field/update/";

export const SECTIONS_PATH = "/employee/sections/list/";
export const SECTION_ITEM_PATH = "/employee/section/item/";
export const SECTION_CREATE_PATH = "/employee/section/create/";
export const SECTION_UPDATE_PATH = "/employee/section/update/";
export const SINCRONIZAR_PATH = "/employee/section/sincronizar/";

export const FIELD_TYPES_PATH = "/employee/field-types/list/";

export const GROUPS_SECTION_PATH = "/employee/groups/list/";
export const GROUP_ITEM_PATH = "/employee/group/item/";
export const GROUP_CREATE_PATH = "/employee/group/create/";
export const GROUP_UPDATE_PATH = "/employee/group/update/";


export const FIELD_ITEM_PATH = "/employee/field/item/";
export const FIELD_CREATE_PATH = "/employee/field/create/";
export const FIELD_UPDATE_PATH = "/employee/field/update/";

export const FIELD_OPTION_CREATE_PATH = "/employee/field-option/create/";
export const FIELD_OPTION_DELETE_PATH = "/employee/field-option/delete/";

export const QR_CONFIGURATION_PATH = "/employee/qr-configuration/list/";
export const QR_CONFIGURATION_CREATE_PATH = "/employee/qr-configuration/create/";
export const QR_CONFIGURATION_UPDATE_PATH = "/employee/qr-configuration/update/";
export const GENERATE_QR_PATH = "/employee/qr_configuration/generate/qr/";

export const TYPE_NOVELTY_PATH = "/novelty/type/list/";
export const TYPE_NOVELTY_CREATE_PATH = "/novelty/type/create/";
export const TYPE_NOVELTY_UPDATE_PATH = "/novelty/type/update/";
export const TYPE_NOVELTY_DELETE_PATH = "/novelty/type/delete/";

export const OPERATOR_PATH = "/novelty/operator/list/";
export const OPERATOR_CREATE_PATH = "/novelty/operator/create/";
export const OPERATOR_UPDATE_PATH = "/novelty/operator/update/";
export const OPERATOR_DELETE_PATH = "/novelty/operator/delete/";

export const NOVELTY_PATH = "/novelty/list/";
export const NOVELTY_ITEM_PATH = "/novelty/item/";
export const NOVELTY_CREATE_PATH = "/novelty/create/";
export const NOVELTY_UPDATE_PATH = "/novelty/update/";
export const NOVELTY_SUPER_UPDATE_PATH = "/novelty/update/super/";
export const NOVELTY_REPORT_PATH = "/novelty/report/";

export const SUPERVISOR_PATH = "/note/supervisor/list/";
export const SUPERVISOR_CREATE_PATH = "/note/supervisor/create/";
export const SUPERVISOR_UPDATE_PATH = "/note/supervisor/update/";
export const SUPERVISOR_DELETE_PATH = "/note/supervisor/delete/";

export const TURN_PATH = "/note/turn/list/";
export const TURN_CREATE_PATH = "/note/turn/create/";
export const TURN_UPDATE_PATH = "/note/turn/update/";
export const TURN_DELETE_PATH = "/note/turn/delete/";

export const NOTE_PATH = "/note/list/";
export const NOTE_ITEM_PATH = "/note/item/";
export const NOTE_CREATE_PATH = "/note/create/";
export const NOTE_REPORT_PATH = "/note/report/";

export const TYPE_CUSTODY_PATH = "/custody/type/list/";
export const TYPE_CUSTODY_CREATE_PATH = "/custody/type/create/";
export const TYPE_CUSTODY_UPDATE_PATH = "/custody/type/update/";
export const TYPE_CUSTODY_DELETE_PATH = "/custody/type/delete/";

export const CUSTODIAN_PATH = "/custody/custodian/list/";
export const CUSTODIAN_CREATE_PATH = "/custody/custodian/create/";
export const CUSTODIAN_UPDATE_PATH = "/custody/custodian/update/";
export const CUSTODIAN_DELETE_PATH = "/custody/custodian/delete/";

export const CUSTODY_PATH = "/custody/list/";
export const CUSTODY_DETAILS_PATH = "/custody/details/";
export const CUSTODY_CREATE_PATH = "/custody/create/";
export const CUSTODY_UPDATE_PATH = "/custody/update/";
export const CUSTODY_REPORT_PATH = "/custody/report/";

export const BONUS_PATH = "/bonus/list/";
export const BONUS_ITEM_PATH = "/bonus/item/";
export const BONUS_CREATE_PATH = "/bonus/create/";
export const BONUS_UPDATE_PATH = "/bonus/update/";
export const BONUS_IMPORT_PATH = "/bonus/import/";
export const BONUS_EXPORT_FILE_PATH = "/bonus/export-file/";

export const TYPE_SHIPPING_REQUEST_PATH = "/tramaco/type/list/";
export const TYPE_SHIPPING_REQUEST_CREATE_PATH = "/tramaco/type/create/";
export const TYPE_SHIPPING_REQUEST_UPDATE_PATH = "/tramaco/type/update/";
export const TYPE_SHIPPING_REQUEST_DELETE_PATH = "/tramaco/type/delete/";

export const REASON_SHIPPING_REQUEST_PATH = "/tramaco/reason/list/";
export const REASON_SHIPPING_REQUEST_CREATE_PATH = "/tramaco/reason/create/";
export const REASON_SHIPPING_REQUEST_UPDATE_PATH = "/tramaco/reason/update/";
export const REASON_SHIPPING_REQUEST_DELETE_PATH = "/tramaco/reason/delete/";

export const SHIPPING_REQUEST_PATH = "/tramaco/list/";
export const SHIPPING_REQUEST_ITEM_PATH = "/tramaco/item/";
export const SHIPPING_REQUEST_CREATE_PATH = "/tramaco/create/";
export const SHIPPING_REQUEST_UPDATE_PATH = "/tramaco/update/";
export const SHIPPING_REQUEST_REPORT_PATH = "/tramaco/report/";

export const CATEGORY_MAINTENANCE_PATH = "/maintenance/category/list/";
export const CATEGORY_MAINTENANCE_CREATE_PATH = "/maintenance/category/create/";
export const CATEGORY_MAINTENANCE_UPDATE_PATH = "/maintenance/category/update/";

export const TYPE_MAINTENANCE_PATH = "/maintenance/type/list/";
export const TYPE_MAINTENANCE_CREATE_PATH = "/maintenance/type/create/";
export const TYPE_MAINTENANCE_UPDATE_PATH = "/maintenance/type/update/";
export const TYPE_MAINTENANCE_DELETE_PATH = "/maintenance/type/delete/";

export const REASON_MAINTENANCE_PATH = "/maintenance/reason/list/";
export const REASON_MAINTENANCE_CREATE_PATH = "/maintenance/reason/create/";
export const REASON_MAINTENANCE_UPDATE_PATH = "/maintenance/reason/update/";
export const REASON_MAINTENANCE_DELETE_PATH = "/maintenance/reason/delete/";

export const MAINTENANCE_PATH = "/maintenance/list/";
export const MAINTENANCE_ITEM_PATH = "/maintenance/item/";
export const MAINTENANCE_CREATE_PATH = "/maintenance/create/";
export const MAINTENANCE_UPDATE_PATH = "/maintenance/update/";
export const MAINTENANCE_REPORT_PATH = "/maintenance/report/";

export const MAINTENANCE_SURVEY_PATH = "/maintenance/survey/list/";
export const MAINTENANCE_SURVEY_CREATE_PATH = "/maintenance/survey/create/";
export const MAINTENANCE_SURVEY_DETAILS_PATH = "/maintenance/survey/item/";
export const MAINTENANCE_SURVEY_UPDATE_PATH = "/maintenance/survey/update/";

export const MAINTENANCE_SURVEY_OPTION_CREATE_PATH = "/maintenance/survey/option/create/";
export const MAINTENANCE_SURVEY_OPTION_UPDATE_PATH = "/maintenance/survey/option/update/";

export const MAINTENANCE_SURVEY_RESULTS_CREATE_PATH = "/maintenance/survey/results/create/";

export const REASON_PURCHASES_PATH = "/purchases/reason/list/";
export const REASON_PURCHASES_CREATE_PATH = "/purchases/reason/create/";
export const REASON_PURCHASES_UPDATE_PATH = "/purchases/reason/update/";

export const PRODUCT_TYPE_PATH = "/purchases/product/type/list/";
export const PRODUCT_TYPE_CREATE_PATH = "/purchases/product/type/create/";
export const PRODUCT_TYPE_UPDATE_PATH = "/purchases/product/type/update/";

export const PRODUCT_PATH = "/purchases/product/list/";
export const PRODUCT_CREATE_PATH = "/purchases/product/create/";
export const PRODUCT_UPDATE_PATH = "/purchases/product/update/";

export const PURCHASE_PATH = "/purchases/list/";
export const PURCHASE_ITEM_PATH = "/purchases/item/";
export const PURCHASE_CREATE_PATH = "/purchases/create/";
export const PURCHASE_UPDATE_PATH = "/purchases/update/";
export const PURCHASE_REPORT_PATH = "/purchases/report/";

export const DETAIL_PURCHASE_CREATE_PATH = "/purchases/detail/create/";
export const DETAIL_PURCHASE_UPDATE_PATH = "/purchases/detail/update/";
export const DETAIL_PURCHASE_DELETE_PATH = "/purchases/detail/delete/";

export const VEHICLE_PATH = "/vehicles/list/";
export const VEHICLE_ITEM_PATH = "/vehicles/item/";
export const VEHICLES_ITEM_PATH = "/vehicles/mantenimiento/item/";
export const VEHICLE_CREATE_PATH = "/vehicles/create/";
export const VEHICLE_UPDATE_PATH = "/vehicles/update/";

export const SERVICE_PATH = "/vehicles/service/list/";
export const SERVICE_CREATE_PATH = "/vehicles/service/create/";
export const SERVICE_UPDATE_PATH = "/vehicles/service/update/";

export const MAINTENANCE_SUPPLIER_PATH = "/vehicles/maintenance/supplier/list/";
export const MAINTENANCE_SUPPLIER_CREATE_PATH = "/vehicles/maintenance/supplier/create/";
export const MAINTENANCE_SUPPLIER_UPDATE_PATH = "/vehicles/maintenance/supplier/update/";

export const VEHICLE_MAINTENANCE_PATH = "/vehicles/maintenance/list/";
export const VEHICLE_MAINTENANCE_ITEM_PATH = "/vehicles/maintenance/item/";
export const VEHICLE_MAINTENANCE_CREATE_PATH = "/vehicles/maintenance/create/";
export const VEHICLE_MAINTENANCE_UPDATE_PATH = "/vehicles/maintenance/update/";

export const EMPLOYEE_VEHICLE_CREATE_PATH = "/vehicles/employee/create/";

export const LOG_MILEAGE_VEHICLE_LIST_PATH = "/vehicles/log/mileage/list/";
export const LOG_MILEAGE_VEHICLE_CREATE_PATH = "/vehicles/log/mileage/create/";
export const LOG_MILEAGE_VEHICLE_UPDATE_PATH = "/vehicles/log/mileage/update/";

export const SERVICE_VEHICLE_MAINTENANCE_CREATE_PATH = "/vehicles/maintenance/service/create/";
export const SERVICE_VEHICLE_MAINTENANCE_DELETE_PATH = "/vehicles/maintenance/service/delete/";

export const ITEM_VEHICLE_MAINTENANCE_CREATE_PATH = "/vehicles/maintenance/item/create/";
export const ITEM_VEHICLE_MAINTENANCE_UPDATE_PATH = "/vehicles/maintenance/item/update/";
export const DATE_MAINTENANCE_UPDATE_PATH = "/vehicles/maintenance/update/item/";
export const VEHICLE_MAINTENANCE_REPORT_PATH = "/vehicles/maintenance/report/";

export const NOVELTY_VEHICLE_MAINTENANCE_PATH = "/vehicles/maintenance/novelty/list/";
export const NOVELTY_VEHICLE_MAINTENANCE_ITEM_PATH = "/vehicles/maintenance/novelty/item/";
export const NOVELTY_VEHICLE_MAINTENANCE_CREATE_PATH = "/vehicles/maintenance/novelty/create/";
export const NOVELTY_VEHICLE_MAINTENANCE_UPDATE_PATH = "/vehicles/maintenance/novelty/update/";
export const NOVELTY_VEHICLE_MAINTENANCE_REPORT_PATH = "/vehicles/maintenance/novelty/report/";

export const VACANCIES_NOTIFICATION_PATH = "/vacancies/notification/list/";
export const VACANCIES_NOTIFICATION_CREATE_PATH = "/vacancies/notification/create/";
export const VACANCIES_NOTIFICATION_UPDATE_PATH = "/vacancies/notification/update/";
export const VACANCIES_NOTIFICATION_DELETE_PATH = "/vacancies/notification/delete/";

export const VACANCIES_PATH = "/vacancies/list/";
export const VACANCIES_CREATE_PATH = "/vacancies/create/";
export const VACANCIES_DETAILS_PATH = "/vacancies/item/";
export const VACANCIES_UPDATE_PATH = "/vacancies/update/";
export const VACANCIES_REPORT_PATH = "/vacancies/report/";

const BASE_CREADO = "CREADO";
const BASE_EN_ESPERA = "EN ESPERA";
const BASE_PENDIENTE_VISITA_ZONAL = "PENDIENTE VISITA ZONAL";
const SALIDA_REQUERIDA = "SALIDA REQUERIDA";
const BASE_APROBADO = "APROBADO";
const BASE_ANULADO = "ANULADO";
const BASE_CANCELADO = "CANCELADO";
const BASE_CADUCADO = "CADUCADO";
const SALIDA_APROBADA = "SALIDA APROBADA";
const SALIDA_DENEGADA = "SALIDA DENEGADA";
const SALIDA_RECHAZADA = "SALIDA RECHAZADA";
const RETORNO_RECHAZADO = "RETORNO RECHAZADO";
const RETORNO_REQUERIDO = "RETORNO REQUERIDO";
const SALIDA_ACEPTADA = "SALIDA ACEPTADA";
const RETORNO_ACEPTADO = "RETORNO ACEPTADO";
const INGRESO_REQUERIDO = "INGRESO REQUERIDO";
const INGRESO_APROBADO = "INGRESO APROBADO";
const PENDIENTE_APROBAR = "PENDIENTE APROBAR";
const INGRESO_ACEPTADO = "INGRESO ACEPTADO";
const SOLICITUD_CREADA = "SOLICITUD CREADA";
const SOLICITUD_EN_CURSO = "SOLICITUD EN CURSO";
const SOLICITUD_APROBADA = "SOLICITUD APROBADA";
const SOLICITUD_RECHAZADA = "SOLICITUD RECHAZADA";
const SOLICITUD_DESPACHADA = "SOLICITUD DESPACHADA";
const SOLICITUD_RECIBIDA = "SOLICITUD RECIBIDA";

const MANTENIMIENTO_CREADO = "MANTENIMIENTO CREADO";
const MANTENIMIENTO_APROBADO = "MANTENIMIENTO APROBADO";
const MANTENIMIENTO_ACEPTADO = "MANTENIMIENTO ACEPTADO";
const MANTENIMIENTO_EJECUTADO = "MANTENIMIENTO EJECUTADO";
const MANTENIMIENTO_FINALIZADO = "MANTENIMIENTO FINALIZADO";
const MANTENIMIENTO_RECHAZADO = "MANTENIMIENTO RECHAZADO";

const RECHAZADO = "RECHAZADO";
const ACEPTADO = "ACEPTADO";
const AJUSTES_ADICIONALES = "AJUSTES ADICIONALES";
const COTIZADO = "COTIZADO";
const CONFIRMADO = "CONFIRMADO";
const PENDIENTE = "PENDIENTE";
const PUBLICADO = "PUBLICADO";

const FINALIZADO = "FINALIZADO";

export const get_status = (status) => {
  switch (status) {
    case BASE_CREADO:
      return "primary";
    case BASE_EN_ESPERA:
      return "warning";
    case BASE_PENDIENTE_VISITA_ZONAL:
      return "warning";
    case SALIDA_REQUERIDA:
      return "warning";
    case BASE_APROBADO:
      return "success";
    case BASE_ANULADO:
      return "danger";
    case BASE_CANCELADO:
      return "danger";
    case BASE_CADUCADO:
      return "dark";
    case SALIDA_APROBADA:
        return "info";
    case SALIDA_DENEGADA:
      return "danger";
      case SALIDA_RECHAZADA:
      return "danger";
    case RETORNO_RECHAZADO:
      return "warning";
    case RETORNO_REQUERIDO:
      return "warning";
    case SALIDA_ACEPTADA:
      return "success";
    case RETORNO_ACEPTADO:
      return "success";
    case INGRESO_REQUERIDO:
        return "warning";
    case PENDIENTE_APROBAR:
        return "warning";
    case INGRESO_APROBADO:
        return "info";
    case INGRESO_ACEPTADO:
        return "success";
    case SOLICITUD_CREADA:
        return "primary";
    case SOLICITUD_EN_CURSO:
        return "warning";
    case SOLICITUD_APROBADA:
        return "success";
    case SOLICITUD_RECHAZADA:
        return "danger";
    case SOLICITUD_DESPACHADA:
        return "info";
    case SOLICITUD_RECIBIDA:
        return "secondary";
    case MANTENIMIENTO_CREADO:
        return "primary";
    case MANTENIMIENTO_APROBADO:
        return "warning";
    case MANTENIMIENTO_ACEPTADO:
        return "info";
    case MANTENIMIENTO_EJECUTADO:
        return "secondary";
    case MANTENIMIENTO_FINALIZADO:
        return "success";
    case MANTENIMIENTO_RECHAZADO:
        return "danger";
    case FINALIZADO:
        return "secondary";
    case ACEPTADO:
        return "info";
    case AJUSTES_ADICIONALES:
        return "info";
    case RECHAZADO:
        return "danger";
    case COTIZADO:
        return "warning";
    case CONFIRMADO:
        return "light";
    case PENDIENTE:
        return "primary";
    case PUBLICADO:
        return "light";
    default:
      return "primary";
  }
};

export const TYPE_EMPLOYEE = "EMPLOYEE";
export const TYPE_VISITANT = "VISITANT";
export const TYPE_ALL = "ALL";
export const TYPE_COMPANY = "COMPANY";

export const APP_NAME = "Sistema de Ingreso";

export const URL_FILE_UPLOAD_EMPLOYEE = "URL_FILE_UPLOAD_EMPLOYEE";
export const URL_FILE_UPLOAD_BONUS = "URL_FILE_UPLOAD_BONUS";
